<template>
  <div
    data-component-id="RecruiterStatus"
  >
    <v-autocomplete
      v-model="recruiterStatus"
      :items="computedItems"
      hide-details
      label="Choisir un statut"
      item-value="value"
      item-text="text"
      outlined
      dense
      :disabled="!canPerformAction('EDIT_APPLICATION')"
      style="max-width: 200px"
      @change="handleChanges"
    >
      <template #item="{ item: recruiterStatusItem }">
        <div :class="copyItem.recruiterStatus === recruiterStatusItem.value ? 'primary--text v-list-item--active v-list-item--highlighted' : ''">
          {{ recruiterStatusItem.text }}
        </div>
      </template>
    </v-autocomplete>

    <v-dialog
      :value="dialog.show"
      persistent
      max-width="500"
    >
      <RecruiterStatusHired
        v-if="dialog.formType === 'hired'"
        :fields="forms.hired.fields"
        :item="copyItem"
        @handle-loading="handleLoading"
        @disagree="resetDialog"
        @close-dialog="closeDialog"
      />
      <RecruiterStatusRecommended
        v-if="dialog.formType === 'recommended'"
        :fields="forms.recommended.fields"
        :item="copyItem"
        @handle-loading="handleLoading"
        @disagree="resetDialog"
        @close-dialog="closeDialog"
      />
      <RecruiterStatusEmploymentPromise
        v-if="dialog.formType === 'send_promise_of_employment'"
        :item="copyItem"
        @handle-loading="handleLoading"
        @disagree="resetDialog"
        @close-dialog="closeDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { requests } from '@/mixins/requests';

import RecruiterStatusHired from '@/components/application/components/RecruiterStatusHired.vue';
import RecruiterStatusRecommended from '@/components/application/components/RecruiterStatusRecommended.vue';
import RecruiterStatusEmploymentPromise from '@/components/application/components/RecruiterStatusEmploymentPromise.vue';

export default {
  name: 'RecruiterStatus',
  components: { RecruiterStatusRecommended, RecruiterStatusEmploymentPromise, RecruiterStatusHired },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      copyItem: {},
      recruiterStatus: null,
      dialog: {
        show: false,
        formType: null
      },
      forms: {
        recommended: {
          fields: [
            {
              name: 'entityUuid',
              label: 'Centre',
              component: 'PositionInput',
              contentWtype: 'entity',
              computed: 'entity.uuid',
              computedLabel: 'entity.name',
              viewType: 'Picker',
              required: true,
              mandatory: true,
              icon: 'domain'
            },
            {
              name: 'offerUuid',
              label: 'Offre',
              component: 'PositionInput',
              contentWtype: 'offer',
              computed: 'offer.uuid',
              computedLabel: 'offer.name',
              required: true,
              mandatory: true,
              viewType: 'Picker'
            },
            {
              name: 'message',
              label: 'Ajouter des notes',
              viewType: 'Textarea',
              icon: 'text-long',
              type: 'text'
            }
          ]
        },
        send_promise_of_employment: {
          fields: [
            {
              name: 'entityUuid',
              label: 'Centre',
              component: 'PositionInput',
              contentWtype: 'entity',
              computed: 'entity.uuid',
              computedLabel: 'entity.name',
              viewType: 'Picker',
              required: true,
              mandatory: true,
              icon: 'domain'
            },
            {
              name: 'offerUuid',
              label: 'Offre',
              component: 'PositionInput',
              contentWtype: 'offer',
              computed: 'offer.uuid',
              computedLabel: 'offer.name',
              required: true,
              mandatory: true,
              viewType: 'Picker'
            },
            {
              name: 'message',
              label: 'Ajouter des notes',
              viewType: 'Textarea',
              icon: 'text-long',
              type: 'text'
            }
          ]
        },
        hired: {
          fields: [
            {
              name: 'coveredETPS',
              label: '(Exemple: 0.6)',
              component: 'GenericField',
              viewType: 'Text',
              required: true,
              mandatory: true
            },
            {
              name: 'message',
              label: 'Ajouter des notes',
              viewType: 'Textarea',
              icon: 'text-long',
              type: 'text'
            }
          ]
        }
      }
    };
  },
  computed: {
    ...mapState(['references', 'user']),
    ...mapGetters(['canPerformAction']),
    computedItems () {
      const recruiterStatusDashboardItems = this.getFieldReferences('recruiterStatusDashboard');

      if (!this.copyItem.recruiterStatus) return recruiterStatusDashboardItems;

      const foundedItem = recruiterStatusDashboardItems.find(item => item.value === this.copyItem.recruiterStatus);

      if (!foundedItem) {
        const recruiterStatusItems = this.getFieldReferences('recruiterStatus');
        recruiterStatusDashboardItems.push(recruiterStatusItems.find(item => item.value === this.copyItem.recruiterStatus));
      }

      return recruiterStatusDashboardItems;
    }
  },
  watch: {
    item (value) {
      this.copyItem = this.iniatilizeData(value);
      this.recruiterStatus = value.recruiterStatus;
    }
  },
  mounted () {
    this.copyItem = this.iniatilizeData(this.item);
    this.recruiterStatus = this.copyItem.recruiterStatus;
  },
  methods: {
    iniatilizeData (value) {
      if (value.entity) value.entityUuid = value.entity.uuid;

      return JSON.parse(JSON.stringify(value)) || {};
    },
    handleDisagree () {
      this.copyItem = this.iniatilizeData(this.item);
      this.dialog.show = false;
    },
    async handleChanges (recruiterStatus) {
      if (!recruiterStatus) {
        return;
      }

      this.$emit('handle-loading', true);

      const { uuid } = this.copyItem;

      if (!['RECOMMENDED', 'SEND_PROMISE_OF_EMPLOYMENT', 'HIRED'].includes(recruiterStatus)) {
        await this.saveApplication({ uuid, recruiterStatus }, true);
      } else {
        this.dialog.show = true;
        this.dialog.formType = recruiterStatus.toLowerCase();
      }

      this.$emit('handle-loading', false);
    },
    async saveApplication (input, isEditMode) {
      const response = await requests.saveApplication({
        input,
        isEditMode: isEditMode
      });

      if (!response.success) {
        this.$store.commit('setSnackbar', { text: 'Erreur lors de l\'enregistrement.', color: 'error' });
      } else {
        this.copyItem = this.iniatilizeData(response.data);
        this.$store.commit('setSnackbar', { text: 'Enregistrer avec succès.', color: 'success' });
      }
    },
    handleLoading (value) {
      this.$emit('handle-loading', value);
    },
    getFieldReferences (optionsByReference) {
      if (!optionsByReference) return [];

      return Object.entries(this.references[optionsByReference]).map(([key, value]) => ({ text: value, value: key }));
    },
    resetDialog () {
      this.recruiterStatus = this.copyItem.recruiterStatus;

      this.dialog.show = false;
      this.dialog.formType = null;
    },
    closeDialog () {
      this.dialog.show = false;
      this.dialog.formType = null;
    }
  }
};
</script>
